import{jsxs as o,Fragment as r,jsx as t}from"react/jsx-runtime";import{styled as i}from"styled-components";import{useProcessingMonth as e}from"../../../context/ProcessingMonthContext.mjs";import{useItemNames as n}from"../../../../domain/hooks/useItemName.mjs";import{labelName as p}from"../../../../domain/domain/UI/Label.name.mjs";const s=i.div`
  float: left;
  width: 60px;
  height: 24px;
  margin: 7px 2px auto auto;
  line-height: 24px;
  text-align: center;
  border: 1px solid #666;
  border-radius: 8px;
  background: url('images/header_black.png') repeat-x #3a3a49;

  &&.processing-month-1 {
    margin-right: 0px;
    border-radius: 8px 0px 0px 8px;
  }
  &&.processing-month-2 {
    width: 70px;
    font-weight: bold;
    border-left: 0px;
    border-radius: 0px 8px 8px 0px;
  }
`,a=i.div`
  position: absolute;
  top: 32px;
  left: 150px;
  background-color: #ffffcc;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 3px;
  opacity: 0.75;
`;function d(){const i=n(p),{processingMonth:d}=e();return o(r,{children:[t(s,{id:"processing-month-1",className:"processing-month-1",children:i("processingMonth")}),t(s,{id:"processing-month-2",className:"processing-month-2",children:d}),t(a,{id:"popup-information"})]})}export{d as ProcessingMonthLabel};
